export default __webpack_public_path__ + "static/media/trees.0895c13a.svg";